"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveModesComparison = exports.NEVER_REVIEWED_DRIVE_MODE_COLUMNS = exports.DRIVE_MODE_VALUE_COLUMNS = exports.DRIVE_MODE_KEY_COLUMNS = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const value_comparison_1 = require("../../Comparison/value-comparison");
const si_comparison_1 = require("../../Comparison/si-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.DRIVE_MODE_KEY_COLUMNS = ['signalName', 'inputType', 'outputType', 'conditionId'];
exports.DRIVE_MODE_VALUE_COLUMNS = [
    'outputHighVoltage',
    'outputLowVoltage',
    'inputHighVoltage',
    'inputLowVoltage',
];
exports.NEVER_REVIEWED_DRIVE_MODE_COLUMNS = [
    'internalPullupBiasImpedance',
    'internalPullupBiasVoltageReference',
    'internalPullupBiasSignalReference',
    'internalPulldownBiasImpedance',
    'internalPulldownBiasVoltageReference',
    'internalPulldownBiasSignalReference',
    'outputImpedance',
];
const reviewedDriveModeColumns = exports.DRIVE_MODE_VALUE_COLUMNS;
const overlappingDriveModeColumns = exports.NEVER_REVIEWED_DRIVE_MODE_COLUMNS.filter((column) => reviewedDriveModeColumns.includes(column));
if (overlappingDriveModeColumns.length > 0) {
    throw new Error(`Drive-mode column is both reviewed and never-reviewed: ${overlappingDriveModeColumns.join(', ')}`);
}
const SIGNAL_NAME_COLUMNS = new Set(['signalName']);
const SI_COLUMN_CHARACTERISTICS = new Map([
    ['outputHighVoltage', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['outputLowVoltage', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['inputHighVoltage', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['inputLowVoltage', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['internalPullupBiasVoltageReference', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['internalPulldownBiasVoltageReference', sigma_engine_shared_1.BoundaryCharacteristic.Voltage],
    ['internalPullupBiasImpedance', sigma_engine_shared_1.BoundaryCharacteristic.Resistance],
    ['internalPulldownBiasImpedance', sigma_engine_shared_1.BoundaryCharacteristic.Resistance],
    ['outputImpedance', sigma_engine_shared_1.BoundaryCharacteristic.Resistance],
]);
class DriveModesComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(exports.DRIVE_MODE_KEY_COLUMNS, exports.DRIVE_MODE_VALUE_COLUMNS);
        this.membershipScopeColumns = ['signalName'];
    }
    toRows(data) {
        return data.map(({ signalId, ...rest }) => ({ ...rest, signalName: signalId }));
    }
    fromRows(rows) {
        return rows.map(({ signalName, ...rest }) => ({ ...rest, signalId: signalName }));
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (SIGNAL_NAME_COLUMNS.has(column) && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        const characteristic = SI_COLUMN_CHARACTERISTICS.get(column);
        if (characteristic !== undefined && typeof value === 'string') {
            return (0, si_comparison_1.formatSIOrSymbolicValue)(value, characteristic);
        }
        return super.normalize(column, value, row);
    }
}
exports.DriveModesComparison = DriveModesComparison;
//# sourceMappingURL=drive-modes.comparison.js.map